


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import num2Chinese from '@/apps/ice/utils/chinese_num'
import { State, Action, namespace } from 'vuex-class'
import Mood from '@/model/plan/mood'
import { TimelineMax } from 'gsap'
import emojiBounce from './emojiBounce'
import moment from 'moment'

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component
export default class TodayInfo extends Vue {
  @ModuleStudyPlan.State((state) => state.mood)
  private mood!: Mood
  @ModuleStudyPlan.State((state) => state.weather)
  private weather!: any
  @ModuleStudyPlan.Action('fetchWeather')
  private fetchWeather!: Function

  mounted() {
    this.fetchWeather()
  }

  get dateStrToday() {
    const date = moment().format("MM.DD")
    const now = new Date()
    const day = now.getDay() === 7 ? '日' : num2Chinese(now.getDay())
    return { date, day: `星期${day}` }
  }

  weatherIcon(icon: string) {
    return `background-image: url(https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/ice/study-plan/weather-${icon}.png);`
  }

  get avatar() {
    let avatar =
      '//style.youkeda.com/img/ice/default_icon.png?x-oss-process=image/resize,m_mfit,h_150,w_150'
    if (this.mood && this.mood.account) {
      const account = this.mood.account
      if (account && account.user && account.user.avatarUrl) {
        avatar = account.user.avatarUrl
        if (
          (!avatar && avatar.indexOf('oss-cn-hangzhou.aliyuncs.com') !== -1) ||
          avatar.indexOf('youkeda.com') !== -1
        ) {
          avatar = `${avatar}?x-oss-process=image/resize,m_mfit,h_150,w_150`
        }
      }
    }
    return avatar
  }

  @Watch('mood')
  onChange() {
    if (this.mood) {
      this.$nextTick(() => {
        this.emojiTimeline()
      })
    }
  }

  emojiTimeline() {
    var bounceTL = new TimelineMax({
      paused: true,
      repeat: -1,
      repeatDelay: 20,
    })
    bounceTL.set('#sp_t_info_emoji', {
      transformOrigin: '50% 50%',
      x: 0,
      y: 0,
    })
    window.requestAnimationFrame(() => {
      bounceTL
        .add(emojiBounce('#sp_t_info_emoji'))
        .progress(1)
        .progress(0)
        .timeScale(1.5)
        .play()
    })
  }
}
